import React from 'react';

export const AboutSection = ({ image, onBookSession }) => {
  return (
    <section id="about" className="about-section section-spacing">
      <div className="revolt-container">
        <div className="about-heading">
          <h2 className="section-title" data-testid="about-section-title">About</h2>
        </div>
        <div className="about-grid">
          <div className="about-image fade-in-up">
            <img 
              src={image}
              alt="About Elina K."
            />
          </div>
          <div className="about-content fade-in-up stagger-1">
            <p className="about-text">
              My name is Elina. I've loved photography for as long as I can remember, 
              and after becoming a mother, I found my way back to it.
            </p>
            <p className="about-text">
              For me, photography is about keeping the moments that feel ordinary today, 
              but may become some of the most meaningful ones later. A photograph lets us 
              return to a certain day, remember how it felt, and experience those happy 
              memories again.
            </p>
            <p className="about-text">
              Originally from Ukraine, I've lived in Dubai since 2019. I'm a mother, 
              a wife and a dog lover. I love to travel and dream of photographing people 
              and their stories in different corners of the world.
            </p>
            <div className="text-center">
              <button 
                onClick={onBookSession}
                className="hero-cta mt-lg"
                data-testid="about-book-session-btn"
              >
                Book a Session
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
